import Input from "@ui-components/Input";
import AuthenticationService from "@services/AuthenticationService";
import Modal from "../../Modal";
import { useState } from "react";
import { useIntl } from "react-intl";
import Button from "../../Button";
import { CITY_REGEX, ZIP_CODE_REGEX } from "../../../utils/regex";

export default function EditCityAndZipCodeModal({
  updatingValue,
  setUpdatingValue,
  onConfirm,
  onClose,
}) {

  const intl = useIntl();
  return <Modal
    onExit={onClose}
    >
    <div className={"p-5"}>
      <Input
        label={intl.formatMessage({id: "city", defaultMessage: "Città"})}
        value={updatingValue.city}
        onChange={(e) => {
          setUpdatingValue({...updatingValue, city: e.target.value})
        }}
        validation={(value) => CITY_REGEX.test(value)}
        errorMessage={intl.formatMessage({id: "city_error", defaultMessage: "Città non valida"})}
        required
      />
      <Input
        label={intl.formatMessage({id: "zip_code", defaultMessage: "CAP"})}
        value={updatingValue.zip_code}
        onChange={(e) => {
          setUpdatingValue({...updatingValue, zip_code: e.target.value})
        }}
        validation={(value) => ZIP_CODE_REGEX.test(value)}
        errorMessage={intl.formatMessage({id: "zip_code_error", defaultMessage: "CAP non valido"})}
        required
      />
      <div className={"flex justify-center mt-5 gap-x-2"}>
        <Button
          onClick={async () => {
            if (!CITY_REGEX.test(updatingValue.city) ||
              !ZIP_CODE_REGEX.test(updatingValue.zip_code) ||
              updatingValue.city.trim() === "" ||
              updatingValue.zip_code.trim() === "") {
              return;
            }
            await onConfirm();
          }}

        >
          {intl.formatMessage({id: "save", defaultMessage: "Salva"})}
        </Button>
        <Button
          styleType="empty"
          onClick={onClose}
        >
          {intl.formatMessage({id: "cancel", defaultMessage: "Annulla"})}
        </Button>
      </div>
    </div>
  </Modal>
}